<template lang="html">
  <root class="admin-view-dish">

    <admin-nav></admin-nav>
    <page-header name="View dish" :count="false"></page-header>

    <!-- Data -->
    <div class="container">
      <div class="row">
        <div class="col m6 offset-m3">
          <table class="striped" v-if="_.size(dish) /*&& display_photo && cover_photo*/">
            <tbody>
              <tr>
                <th>Display photo</th>
                <td>
                  <img v-if="display_photo" :src="display_photo" alt="">
                  <span v-else>Not Available</span>
                </td>
              </tr>
              <tr>
                <th>Cover photo</th>
                <td>
                  <img v-if="cover_photo" :src="cover_photo" alt="">
                  <span v-else>Not Available</span>
                </td>
              </tr>
              <tr>
                <th>Name (EN)</th>
                <td><span v-if="dish.name">{{ dish.name.en }}</span></td>
              </tr>
              <tr>
                <th>Name (AR)</th>
                <td><span v-if="dish.name">{{ dish.name.ar }}</span></td>
              </tr>
              <tr>
                <th>Description (EN)</th>
                <td><span v-if="dish.description">{{ dish.description.en }}</span></td>
              </tr>
              <tr>
                <th>Description (AR)</th>
                <td><span v-if="dish.description">{{ dish.description.ar }}</span></td>
              </tr>
              <tr>
                <th>Price</th>
                <td>{{ dish.price }}</td>
              </tr>
              <tr>
                <th>Type</th>
                <td>{{ __typeName(dish.type) }}</td>
              </tr>
              <tr>
                <th>Instant</th>
                <td>{{ dish.is_instant ? 'Yes' : 'No' }}</td>
              </tr>
              <tr v-if="dish.is_instant">
                <th>Stock</th>
                <td>{{ dish.stock }}</td>
              </tr>
              <tr>
                <th>Created at</th>
                <td>{{ new Date(dish.timestamp).toLocaleString() }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <preloader :is-active="!_.size(dish)"></preloader>
  </root>
</template>

<script>
import * as firebase from "firebase";

export default {
  data() {
    return {
      dish: {},
      display_photo: "",
      cover_photo: "",
    };
  },
  methods: {
    // Collect
    collectDish() {
      firebase
        .database()
        .ref("dishes/" + this.$route.params.dishKey)
        .once("value")
        .then((dishSnap) => {
          // Data
          let dishData = dishSnap.val();

          // Push
          this.dish = dishData;

          // Display photo
          var displayPhotoKey = null;
          if (dishData.is_display_photo_updated == true) {
            displayPhotoKey = dishSnap.key;
          } else {
            displayPhotoKey = dishData.old_key;
          }
          firebase
            .storage()
            .ref("dish/display/" + displayPhotoKey + ".jpeg")
            .getDownloadURL()
            .then((display) => {
              if (display != null) {
                this.display_photo = display + ".jpeg";
              }
            })
            .catch((error) => {
              // A full list of error codes is available at
              // https://firebase.google.com/docs/storage/web/handle-errors
              switch (error.code) {
                case "storage/object-not-found":
                  console.log("File doesn't exist");
                  break;
                case "storage/unauthorized":
                  console.log(
                    "User doesn't have permission to access the object"
                  );
                  break;
                case "storage/canceled":
                  console.log("User canceled the upload");
                  break;
                case "storage/unknown":
                  console.log(
                    "Unknown error occurred, inspect the server response"
                  );
                  break;
              }
            });

          // Cover photo
          var coverPhotoKey = null;
          if (dishData.is_cover_photo_updated == true) {
            coverPhotoKey = dishSnap.key;
          } else {
            coverPhotoKey = dishData.old_key;
          }
          firebase
            .storage()
            .ref("dish/cover/" + coverPhotoKey  + ".jpeg")
            .getDownloadURL()
            .then((cover) => {
              if (cover != null) {
                this.cover_photo = cover + ".jpeg";
              }
            })
            .catch((error) => {
              // A full list of error codes is available at
              // https://firebase.google.com/docs/storage/web/handle-errors
              switch (error.code) {
                case "storage/object-not-found":
                  console.log("File doesn't exist");
                  break;
                case "storage/unauthorized":
                  console.log(
                    "User doesn't have permission to access the object"
                  );
                  break;
                case "storage/canceled":
                  console.log("User canceled the upload");
                  break;
                case "storage/unknown":
                  console.log(
                    "Unknown error occurred, inspect the server response"
                  );
                  break;
              }
            });
        });
    },

    // Dish type name
    __typeName(type) {
      return _.upperFirst(_.replace(type, "_", " "));
    },
  },
  mounted() {
    this.collectDish();
  }
};
</script>

<style lang="scss">
.admin-view-dish {
  img {
    max-height: 75px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/DishView.vue